module.exports = __webpack_public_path__ + "img/c.97d8a209.jpg";